import Vue from 'vue'
class ConfigHelper {
  /**
   * 
   * @param {*} state 
   * @param {string} configName 
   * @param {function} generator 
   * @returns 
   */
  getConfig (state, configName, generator, cacheable) {
    if (!state || !cacheable) return typeof generator === 'function' ? generator() : []
    if (!state.cache[configName]) {
      if (typeof generator !== 'function') return []
      const configData = generator()
      this.loadConfig(state, { configName, configData })
    } else { 
      this.extendCacheTime(state, configName) 
    }
    return state.cache[configName]
  }

  /**
   * 
   * @param {*} state 
   * @param {object} param1
   * @param {string} param1.configName
   * @param {array} param1.configData
   */
  loadConfig (state, { configName, configData }) {
    Vue.set(state.cache, configName, configData)
    this.extendCacheTime(state, configName)
  }

  /**
   * 
   * @param {*} state 
   * @param {string} configName 
   */
  extendCacheTime (state, configName) {
    Vue.set(state.lastUsed, configName, Date.now())
  }
}

export default new ConfigHelper()
